import { Link } from "react-router-dom";
import Button from "@/common/components/Button";
import { ArrowBigRight } from "lucide-react";
import { TmaisRaffleData } from "../types/tmaisRaffles.type";
import { formatDate, formatDateTime } from "@/common/utils/formatters";
import { tmaisRafflesStatusStrategy } from "../constants/statusOptions.constant";

export class TmaisRafflesTransformer {
  static tableTransformer() {
    return (tmaisRaffles: TmaisRaffleData[]) => {
      return tmaisRaffles.map((raffle) => {
        return {
          ...raffle,
          status: raffle.status ? tmaisRafflesStatusStrategy[raffle.status as keyof typeof tmaisRafflesStatusStrategy] : '--',
          author: raffle.creator_establishment_company_branch ? raffle.creator_establishment_company_branch?.general_information?.fantasy_name : 'Tcard',
          available_until: raffle?.available_until ? formatDate(new Date(raffle.available_until)) : undefined,
          select_winner_at: raffle?.select_winner_at ? formatDateTime(new Date(raffle.select_winner_at)) : undefined,
          actions: (
            <Link to={raffle.id}>
              <Button name="access_tmais_raffle_button" variant='link-white' className="w-full" operationKlassToCheckPermission="Admin::Tmais::Raffles::Show">
                <ArrowBigRight />
              </Button>
            </Link>
          )
        };
      });
    };
  }
}
